import React, { Suspense, lazy, useRef, useState, useContext, useEffect } from "react";
import { Link, useNavigate , NavLink } from "react-router-dom";
import { ToastContainer, toast, Zoom } from 'react-toastify';
import { HomeContext } from "../../web/Home";
import  { apibaseURl , currencySymbol , errorToast , successToast , loggedInCustomerDetails }  from "../../functions/Function";
const  OrderForm = (props) => {
  const HomeContextData = useContext(HomeContext);
  const handleClickUpdateOrdersList = HomeContextData.handleClickUpdateOrdersList;
  const [isActive, setisActive] = useState('buy');
   const [id, setId] = useState(props.activeproduct); 
   const [name, setName] = useState(''); 
   const [qty, setQty] = useState(1); 
   const [price, setPrice] = useState(0.00); 
   const [total, setTotal] = useState(0.00); 
   const [buyfeePercetnage, setbuyfeePercetnage] = useState(0); 
   const [buyfeeAmount, setbuyfeeAmount] = useState(200.00); 

   const fetchData = () => {
      fetch(apibaseURl + "getsingleproduct/"+props.activeproduct)
        .then(res => res.json())
        .then((result) => {
          if (result.result == true) {
            if(result.response != null)
            {
              handleClickUpdateOrdersList(true);
              setName(result.response.name);
              setQty(1);
              setPrice(result.response.price);
              setTotal(result.response.price);
             
            }
            
          }
        }
        )
    }

    const changePrice = (price) =>
    {
      setPrice(price)
      var totalPrice = qty*price;
      setTotal(totalPrice);
   }

   const changeQty = (qty) =>
    {
      setQty(qty)
      var totalPrice = qty*price;
      setTotal(totalPrice);
    }

   const calculateFeesAmount = (percentage = '' , amount='') =>
   {
        let percentInDecimal = percentage / 100;
        let txnfees = percentInDecimal * amount;
        setbuyfeeAmount(txnfees);
    }
   const getbuyFeesPercentage = async () => {
      let res = await fetch(apibaseURl + "BuyFeesPercentage");
      let output = await res.json();
      console.log(output);
      if (res.status == 200) 
      {
        if (output.status == true) {
              setbuyfeePercetnage(output.response);
          }
      }

   }
   const handleSubmit = async (e) => {
      e.preventDefault();
      
      try {
        let res = await fetch(apibaseURl + "buyorder", {
          method: "POST",
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            user_id: loggedInCustomerDetails('id'),
            price: price,
            qty: qty,
            product_id: props.activeproduct
         }),
        });
        console.log(res);
        let output = await res.json();
         if (res.status == 200) {
          if (output.result == true) {
                  fetchData();
                  successToast('Your order has been successfully placed' , 'bottom-right' , 1500  , true);  
            }else
            {
                  errorToast(output.response , 'bottom-right' , 1500  , true);
            }
         }
      } catch (err) {
               console.log(err)
      }
    };

    const handleSubmitSellOrder = async (e) => {
      e.preventDefault();
      
      try {
        let res = await fetch(apibaseURl + "sellorder", {
          method: "POST",
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            user_id: loggedInCustomerDetails('id'),
            price: price,
            qty: qty,
            product_id: props.activeproduct
         }),
        });
      
        let output = await res.json();
         if (res.status == 200) {
            console.log(output)
            if (output.result == true) {
                  fetchData();
                  successToast('Your order has been successfully placed' , 'bottom-right' , 1500  , true);  
            }else
            {
                  errorToast(output.response , 'bottom-right' , 1500  , true);
            }
         }
      } catch (err) {
               console.log(err)
      }
    };

    const switchTab = (activeTab='') => 
    {
      fetchData();
      setisActive(activeTab);
    }

    const totalAmt = () => 
    {
      let amt1 = parseFloat(Number(total).toFixed(2));
      let amt2 = parseFloat(Number(buyfeeAmount).toFixed(2));
       // let amt1 = parseFloat(total.toFixed(2));
        //let amt2 = parseFloat(buyfeeAmount.toFixed(2));

      let total_amount = amt1+amt2;
        return parseFloat(total_amount).toFixed(2);
    }
    const selltotalAmt = () => 
    {
      let amt1 = parseFloat(Number(total).toFixed(2));
      let amt2 = parseFloat(Number(buyfeeAmount).toFixed(2));
       // let amt1 = parseFloat(total.toFixed(2));
        //let amt2 = parseFloat(buyfeeAmount.toFixed(2));

      let total_amount = amt1-amt2;
        return parseFloat(total_amount).toFixed(2);
    }

    


    useEffect(() => {
      setId(props.activeproduct);
      getbuyFeesPercentage();
      fetchData();
      
   }, [props.activeproduct])
              
   useEffect(() => {
        console.log('Change Price');
        calculateFeesAmount(buyfeePercetnage , total)
        //setTotal(total+buyfeeAmount)
        
    }, [total])
   
   
  return (
    <>
      { HomeContextData.getActiveProdcutID() > 0 &&
         <>
        <ToastContainer />
        <nav className="ivo-buy-sell-tabs">
            <div className="nav nav-tabs" id="nav-tab" role="tablist">
                <button 
                  className={isActive == 'buy' ? 'ivo-buy-single nav-link active' : 'nav-link ivo-buy-single'}
                  id="nav-home-tab" 
                  onClick={()=>switchTab('buy')}
                
                >BUY</button>
                <button 
                  className={isActive == 'sell' ? 'ivo-buy-single nav-link active' : 'nav-link ivo-buy-single'}
                  id="nav-profile-tab" 
                  onClick={()=>switchTab('sell')}
                >SELL</button>
            </div>
          </nav>

         <div className="tab-content" id="nav-tabContent">
          {isActive == 'buy' &&
            <div className="tab-pane fade show active" 
            id="nav-home" role="tabpanel"
                aria-labelledby="nav-home-tab">
                <div className="ivo-buy-sell-inner-content">
                  <h6 className="mb-2">
                      {name}
                  </h6>
                  <form onSubmit={handleSubmit} >
                      <div className="ivo-sellin-form">
                        <div className="inner-form-buy-de">
                            <span className="inner-form-buy-de-heading">AT PRICE
                            <br /><strong>XOF</strong></span>
                            <input 
                              type="number" 
                              className="form-control" 
                              placeholder=""
                              value={price}
                              
                              onChange={(e) => changePrice(e.target.value)}
                            />
                        </div>
                      </div>
                      <div className="ivo-sellin-form">
                        <div className="inner-form-buy-de">
                            <span className="inner-form-buy-de-heading">QTY
                            </span>
                            <input 
                              type="number" 
                              className="form-control" 
                              placeholder=""
                              value={qty}
                              onChange={(e) => changeQty(e.target.value)}
                              
                               />
                        </div>
                      </div>
                      <div className="ivo-sellin-form">
                        <div className="inner-form-buy-de">
                            <span className="inner-form-buy-de-heading">SUB TOTAL
                            <br /><strong>XOF</strong></span>
                            <input 
                              type="number" 
                              className="form-control" 
                              placeholder="" 
                              value={parseFloat(Number(total).toFixed(2))}
                              readOnly={true}
                           />
                        </div>
                      </div>

                      <div className="ivo-sellin-form">
                        <div className="inner-form-buy-de">
                            <span className="inner-form-buy-de-heading">Charges
                            <br /><strong>XOF</strong></span>
                            <input 
                              type="number" 
                              className="form-control" 
                              placeholder="" 
                              value={buyfeeAmount}
                              readOnly={true}
                           />
                        </div>
                    
                      </div>

                      <div className="ivo-sellin-form">
                        <div className="inner-form-buy-de">
                            <span className="inner-form-buy-de-heading">TOTAL
                            <br /><strong>XOF</strong></span>
                            <input 
                              type="number" 
                              className="form-control" 
                              placeholder="" 
                              value={totalAmt()}
                              readOnly={true}
                           />
                        </div>
                      </div>
                      <button type="submit" className="btn ivo-site-btn buy-btn">BUY</button>
                  </form>
                  
                </div>
            </div>
          }


            {isActive == 'sell' &&     
            <div className="tab-pane fade show active" id="nav-profile" role="tabpanel"
                aria-labelledby="nav-profile-tab">
                <div className="ivo-buy-sell-inner-content">
                  <h6 className="mb-2">
                      {name}
                  </h6>
                  <form onSubmit={handleSubmitSellOrder} >
                  <div className="ivo-sellin-form">
                        <div className="inner-form-buy-de">
                            <span className="inner-form-buy-de-heading">AT PRICE
                            <br /><strong>XOF</strong></span>
                            <input 
                              type="number" 
                              className="form-control" 
                              placeholder=""
                              value={price}
                              
                              onChange={(e) => changePrice(e.target.value)}
                            />
                        </div>
                      </div>
                      <div className="ivo-sellin-form">
                        <div className="inner-form-buy-de">
                            <span className="inner-form-buy-de-heading">QTY
                            </span>
                            <input 
                              type="number" 
                              className="form-control" 
                              placeholder=""
                              value={qty}
                              onChange={(e) => changeQty(e.target.value)}
                              
                               />
                        </div>
                      </div>
                      <div className="ivo-sellin-form">
                        <div className="inner-form-buy-de">
                            <span className="inner-form-buy-de-heading">SUB TOTAL
                            <br /><strong>XOF</strong></span>
                            <input 
                              type="number" 
                              className="form-control" 
                              placeholder="" 
                              value={parseFloat(Number(total).toFixed(2))}
                              readOnly={true}
                           />
                        </div>
                      </div>
                      <div className="ivo-sellin-form">
                        <div className="inner-form-buy-de">
                            <span className="inner-form-buy-de-heading">Charges
                            <br /><strong>XOF</strong></span>
                            <input 
                              type="number" 
                              className="form-control" 
                              placeholder="" 
                              value={buyfeeAmount}
                              readOnly={true}
                           />
                        </div>
                    
                      </div>

                      <div className="ivo-sellin-form">
                        <div className="inner-form-buy-de">
                            <span className="inner-form-buy-de-heading">TOTAL
                            <br /><strong>XOF</strong></span>
                            <input 
                              type="number" 
                              className="form-control" 
                              placeholder="" 
                              value={selltotalAmt()}
                              readOnly={true}
                           />
                        </div>
                      </div>

                      <button type="submit" className="btn ivo-site-btn buy-sell">SELL</button>
                  </form>
                 
                </div>
            </div>
            }


          </div>
         </>
      }
       
    </>

  );
}

export default OrderForm;
